<template>
    <div class="score-container">
        <span class="title-score"> {{ score | toFixed}} </span>
        <span class="subtitle-score"> de 1000 </span>
        <NewProgressBar :type="'SellerScore'" :valor="score ? score : 0"
        class="positionRange" />
        <span class="score-feedback-message">{{ feedbackScoreMessage }}</span>
    </div>
</template>

<script>
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'
export default {
    components: { NewProgressBar },
    filters: {
        toFixed(val) {
            return val ? val.toFixed(1) : 0
        }
    },
    props: {
        score: {
            type: Number,
            default: 0
        }
    },
    computed: {
        feedbackScoreMessage() {
            if (parseInt(this.score) > 0 && parseInt(this.score) <= 333) {
                return 'Score muito baixo'
            } else if (parseInt(this.score) > 333 && parseInt(this.score <= 666)) {
                return 'Score regular'
            } else if (parseInt(this.score) > 666 && parseInt(this.score) <= 1000) {
                return 'O score está muito bom'
            }
            return 'Calculando...';
        },
        redStage() {
            if (parseInt(this.score) <= 333) {
                return parseInt(this.score);
            }
            return 333;
        },
        yellowStage() {
            if(parseInt(this.score) <= 333) {
                return 0
            } else if (parseInt(this.score) > 333 && parseInt(this.score <= 666)) {
                return (parseInt(this.score) - 333);
            }
            return 333;
        },
        greenStage() {
            if(parseInt(this.score) <= 333) {
                return 0
            } else if (parseInt(this.score) > 333 && parseInt(this.score <= 666)) {
                return parseInt(this.score) - 333;
            } else if (parseInt(this.score) > 666 && parseInt(this.score) <= 1000) {
                return parseInt(this.score) - 666
            }
            return 334;
        }
    }
}
</script>

<style scoped>
    .score-container {
        display: flex; 
        flex-direction: column; 
        padding-top: 18px; 
        padding-left: 30px; 
        padding-right: 30px; 
        min-width: 285px; 
        height: 200px; 
        border-radius: 6px; 
        border: 0.5px solid #E5E7E8;
        margin-right: 20px; 
    }
    .title-score {
        font-family: Montserrat;
        font-size: 32px;
        font-weight: 600;
        line-height: 39px;
        letter-spacing: 0.2px;
        text-align: left;
        color: black;
    }
    .subtitle-score {
        margin-top: 10px; 
        font-family: Montserrat;
        font-size: 12px;
        font-weight: 400;
        line-height: 15px;
        letter-spacing: 0.2px;
        text-align: left;
        color: #81858E;
    }
    .score-feedback-message {
        margin-top: 13px; font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        line-height: 17px;
        letter-spacing: 0.2px;
        text-align: left;
        color: black;
    }
    .progress {
        width: 33px;
        height: 6px;
    }
</style>